<div class="cfg-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title"><i class="fal fa-users"></i> Clients</h1>
      <p class="page-header__sub">Tous les clients enregistrés — {{ total }} client(s)</p>
    </div>
    <div class="header-actions">
      <button class="btn-export-clients" (click)="exporterCSV()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        Exporter CSV
      </button>
      <button class="btn-refresh" (click)="charger()" [disabled]="chargement">
        <i class="fal fa-sync" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- KPIs -->
  <div class="kpi-row">
    <div class="kpi-card"><span class="kpi-val">{{ total }}</span><span class="kpi-label">Total</span></div>
    <div class="kpi-card kpi-card--green"><span class="kpi-val">{{ actifs }}</span><span class="kpi-label">Actifs</span></div>
    <div class="kpi-card kpi-card--orange"><span class="kpi-val">{{ inactifs }}</span><span class="kpi-label">Inactifs</span></div>
    <div class="kpi-card kpi-card--blue"><span class="kpi-val">{{ nouveauxCeMois }}</span><span class="kpi-label">Ce mois</span></div>
  </div>

  <!-- Filtres -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltres()" placeholder="Nom, email, téléphone…" />
    </div>
    <select class="filtre-select" [(ngModel)]="filtreActif" (ngModelChange)="appliquerFiltres()">
      <option value="">Tous les statuts</option>
      <option value="actif">Actifs</option>
      <option value="inactif">Inactifs</option>
    </select>
  </div>

  <!-- Chargement -->
  <div class="etat-centre" *ngIf="chargement"><div class="spinner"></div><span>Chargement…</span></div>

  <!-- Vide -->
  <div class="etat-centre" *ngIf="!chargement && clientsFiltres.length === 0">
    <i class="fal fa-users" style="font-size:36px;color:#cbd5e0"></i>
    <p>Aucun client trouvé.</p>
  </div>

  <!-- Tableau -->
  <div class="table-wrapper" *ngIf="!chargement && clientsFiltres.length > 0">
    <table class="data-table">
      <thead>
        <tr>
          <th>Client</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th>Ville</th>
          <th>Inscription</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of clientsFiltres">
          <td>
            <div class="client-avatar-row">
              <span class="client-avatar">{{ nomComplet(c).charAt(0) }}</span>
              <div>
                <strong>{{ nomComplet(c) }}</strong>
                <small style="display:block;font-size:11px;color:#a0aec0">{{ c.username }}</small>
              </div>
            </div>
          </td>
          <td>{{ c.email || '—' }}</td>
          <td>{{ c.contact || c.telephone || '—' }}</td>
          <td>{{ c.ville || '—' }}</td>
          <td>{{ formaterDate(c.dateCreation) }}</td>
          <td>
            <span class="statut-badge" [class.badge-actif]="c.enabled !== false" [class.badge-inactif]="c.enabled === false">
              {{ c.enabled !== false ? 'Actif' : 'Inactif' }}
            </span>
          </td>
          <td>
            <div class="actions-cell">
              <button class="btn-action btn-action--blue" (click)="voirDetail(c)" title="Voir la fiche">
                <i class="fal fa-eye"></i>
              </button>
              <button class="btn-action btn-action--green" *ngIf="c.enabled === false"
                [disabled]="enCoursAction === c.id" (click)="activer(c)" title="Activer">
                <i class="fal fa-check"></i>
              </button>
              <button class="btn-action btn-action--danger" *ngIf="c.enabled !== false"
                [disabled]="enCoursAction === c.id" (click)="desactiver(c)" title="Désactiver">
                <i class="fal fa-ban"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
